import React from "react";

import { useParams } from "react-router-dom";
import masterProgrammesData from "../../../../data/masterProgrammesData";

const HowToPay = () => {

  const { masterProgramme } = useParams();
  const mastersprogram = masterProgrammesData.find(
    (prog) => prog.id === masterProgramme
  );
  const fees = mastersprogram?.fees || [];
  const numberOfInstalments = mastersprogram?.numberOfInstalments || 3; // Default to 2 if not specified
  const totalFees = fees.reduce((total, fee) => total + fee.amount, 0);
  const installmentAmount = totalFees / numberOfInstalments; // Assuming 4 installments for bi-monthly payments

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="how-to-pay">
      <div className="bg-sddarkgray">
        <div className="max-w-6xl mx-auto p-10 space-y-3">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-center text-gray-100">
              HowToPay
            </h1>
            <div className="w-10 h-1 bg-gray-200 mx-auto"></div>

            <div>
              <p className="text-gray-100 px-3">
                You can pay your fees in a number of ways, including an online
                payment facility via the Stripe payment, PayPal, Western Union
                or via bank transfer.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-20">
            <div className="bg-sddarkorange pb-5 rounded-xl shadow-md">
              <div className="flex justify-center">
                <p className="inline-block bg-sdbodywhite p-1 rounded-b-md text-sm">
                  Best Choice
                </p>
              </div>

              <div className="py-5 text-center space-y-7 text-sddarkgray">
                <h3 className="text-lg font-semibold mb-4 text-sddarkgray">
                  One-Time Payment
                </h3>

                <div className="h-0.5 bg-sdbodywhite"></div>
                <p className="text-2xl font-bold  mb-2">
                  {"€" + totalFees.toFixed(2)}
                </p>
                <div className="flex justify-center">
                  <p className="w-2/3 text-center text-sm ">
                    Pay the full programme fee upfront & receive exclusive
                    access to a leadership webinar with an international expert.
                  </p>
                </div>
                <p className=" text-sm">Pay once & save!</p>
              </div>
            </div>

            <div className="bg-sdbodywhite md:my-5 pb-5 rounded-xl shadow-md">

              <div className="flex justify-center">
                <p className="inline-block bg-sddarkorange p-1 rounded-b-md text-sm">
                  Instalment
                </p>
              </div>

              <div className="py-5 text-center space-y-7">
                <h3 className="text-lg font-semibold mb-4">Instalment Plan</h3>

                <div className="h-0.5 bg-gray-600"></div>
                <p className="flex justify-center items-center space-x-1">
                  <span className="text-2xl font-bold text-sddarkorange">
                    {"€" + installmentAmount.toFixed(2)}
                  </span>
                  <p>per instalment.</p>
                </p>
                <div className="text-gray-600">
                  <p className="text-sm">({numberOfInstalments} Instalments)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToPay;
